module.exports = __webpack_public_path__ + "img/6_dp.4ccbdcbe.png";